import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TaskNoneFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 2.68C12.84 2.68 13.76 3.28 13.82 4.66H10.18C10.24 3.28 11.16 2.68 12 2.68ZM5.42 19.84V4.08H9.06V5.72H14.94V4.08H18.58V19.84H5.42Z" />
    </SvgIcon>
  );
});
